"use strict";

exports.__esModule = true;
exports.createControllerState = createControllerState;
var _react = require("react");
var _excluded = ["children"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Create the controller state for a react component.
 */
function createControllerState(component, initialState, getActions) {
  var getState = function getState() {
    return component.state;
  };
  var setState = function setState() {
    return component.setState.apply(component, arguments);
  };
  var unboundActions = getActions({
    getState: getState,
    setState: setState
  });
  var controller = {};
  for (var _i = 0, _Object$keys = Object.keys(unboundActions); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    controller[key] = unboundActions[key].bind(controller);
  }

  // TODO: Figure out a way to check if initialState is of type InitialStateFunction
  if (typeof initialState === "function") {
    return Object.assign({}, initialState(component.props), controller);
  }

  // eslint-disable-next-line no-unused-vars
  var _component$props = component.props,
    children = _component$props.children,
    extra = _objectWithoutPropertiesLoose(_component$props, _excluded);
  return Object.assign({}, extra, controller);
}